module.exports = __webpack_public_path__ + "img/search-black.aa0a73be.svg";